import { useQuery } from "@tanstack/react-query";
import {
  fetchCustomValueParentChildValues,
  FetchCustomValueParentChildValuesResponse
} from "PFCore/services/custom_values";
import { Id } from "PFCore/types";
import { QueryOptions } from "PFTypes/request_options";

import { customValueKeys } from "./query_keys";

export const useCustomValueParentChildValues = <T>(
  id: Id,
  options?: QueryOptions<FetchCustomValueParentChildValuesResponse, any, T>
) =>
  useQuery<FetchCustomValueParentChildValuesResponse, any, T>({
    queryKey: customValueKeys.customValueParentsAndChildren(id),
    queryFn: () => fetchCustomValueParentChildValues(id),
    retry: false,
    ...options
  });
